import { render } from "./BInputNumeric.vue?vue&type=template&id=50f5f728"
import script from "./BInputNumeric.vue?vue&type=script&lang=js"
export * from "./BInputNumeric.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__